import React from 'react';
import {Box, Button} from "@chakra-ui/react";


const RefreshBtn = (props) => {

    return (
        <Box position={"fixed"} top={0} zIndex={99}>
            <Button
                fontWeight ={"600"}
                boxShadow = {" rgb(38, 57, 77) 0px 2px 3px 1px"}
                onClick={()=>{
                    if(props?.onRefresh) props?.onRefresh();
                }}
            >
                SVUOTA FORM
            </Button>
        </Box>
    );
};

export default RefreshBtn;